import { render, staticRenderFns } from "./ProgramConsumption.vue?vue&type=template&id=3551e7f9&scoped=true&"
import script from "./ProgramConsumption.vue?vue&type=script&lang=js&"
export * from "./ProgramConsumption.vue?vue&type=script&lang=js&"
import style0 from "./ProgramConsumption.vue?vue&type=style&index=0&id=3551e7f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3551e7f9",
  null
  
)

export default component.exports